import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MainPage from "./mainPage";
import QuizPage from "./quizPage";
import ResultPage from "./resultPage";
import EnterInfoPage from "./enterInfoPage";
import DetailResultPage from "./detailResultPage";
import AdminPanel from "./adminPanel";

function getCurrentRouteComponent() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";

  if (path === "/quiz") {
    return QuizPage;
  }

  if (path === "/result") {
    return ResultPage;
  }

  if (path === "/enter-info") {
    return EnterInfoPage;
  }

  if (path === "/detail-result") {
    return DetailResultPage;
  }

  if (path === "/admin-panel") {
    return AdminPanel;
  }

  return MainPage;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const AppComponent = getCurrentRouteComponent();

root.render(
  <React.StrictMode>
    <AppComponent />
  </React.StrictMode>,
);
